import { render } from "./app-header-material.vue?vue&type=template&id=79986917&scoped=true&lang=true"
import script from "./app-header-material.vue?vue&type=script&lang=js"
export * from "./app-header-material.vue?vue&type=script&lang=js"

import "./app-header-material.vue?vue&type=style&index=0&id=79986917&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79986917"]])

export default __exports__